import CollectionTabs from './CollectionTabs';

export default CollectionTabs;
